// Generated from api/openapi/operations.yaml by make docs. Do not edit.
import { z } from "zod";

export const changedControlSchema = z.object({
  "snapshot_id": z.string().uuid(),
  "catalog_id": z.string().uuid().nullable().optional(),
  "framework_id": z.string(),
  "framework_version": z.string(),
  "control_id": z.string(),
  "title": z.string(),
  "family": z.string(),
  "severity": z.enum(["critical", "high", "medium", "low"]),
  "status": z.enum(["compliant", "partial", "non_compliant", "not_applicable", "not_assessed"]),
  "previous_status": z.string().optional(),
  "captured_at": z.string(),
  "captured_reason": z.string(),
  "captured_by": z.string().uuid().nullable().optional(),
  "summary": z.string().optional(),
  "confidence": z.string().optional(),
  "treatment": z.string().optional(),
  "evaluator_version": z.string().optional(),
  "prev_hash": z.string().optional(),
  "row_hash": z.string().optional(),
  "customer_control_id": z.string().optional(),
  "contribution_status": z.enum(["compliant", "partial", "non_compliant", "not_applicable", "not_assessed"]).optional(),
  "previous_contribution_status": z.string().optional(),
  "chain_format": z.number().int().optional(),
  "artefacts": z.array(z.object({
    "sha256": z.string(),
    "title": z.string(),
    "sensitivity": z.string()
  })).optional()
});

export const eligibleComplianceReviewersSchema = z.object({
  "data": z.array(z.object({
    "id": z.string().uuid(),
    "email": z.string(),
    "name": z.string().optional()
  }))
});

export const controlListItemSchema = z.object({
  "catalog_id": z.string().uuid(),
  "control_id": z.string(),
  "title": z.string(),
  "family": z.string(),
  "summary": z.string(),
  "requirement": z.string().default(""),
  "section": z.string().default(""),
  "supplier": z.string().default(""),
  "population": z.string().default(""),
  "customer_control_id": z.string().default(""),
  "owner_name": z.string().default(""),
  "owner_role": z.string().default(""),
  "reviewer_name": z.string().default(""),
  "reviewer_role": z.string().default(""),
  "exception_expires_at": z.string().default(""),
  "attestation_expires_at": z.string().default(""),
  "attestation_cited_from": z.string().default(""),
  "compensating_control": z.string().default(""),
  "severity": z.enum(["critical", "high", "medium", "low"]),
  "status": z.enum(["compliant", "partial", "non_compliant", "not_applicable", "not_assessed"]),
  "confidence": z.enum(["auto", "structural", "manual", "override", ""]),
  "treatment": z.enum(["none", "exception", "not_applicable"]).default("none"),
  "design_only": z.boolean().default(false),
  "contribution_status": z.string().optional(),
  "contribution_summary": z.string().optional(),
  "contribution_remediation": z.string().optional(),
  "contribution_observed_at": z.string().optional()
});

export const crosswalkEntrySchema = z.object({
  "framework_id": z.string(),
  "framework_version": z.string(),
  "control_id": z.string(),
  "relationship": z.enum(["equivalent", "narrower", "broader", "related"])
});

export const controlOverrideDetailSchema = z.object({
  "status": z.enum(["not_applicable", "exception_temporary"]),
  "scope_note": z.string(),
  "override_set_by": z.string().uuid().optional(),
  "override_set_by_email": z.string().default(""),
  "override_set_at": z.string().datetime({ offset: true }).optional(),
  "approved_by_email": z.string().default("")
});

export const controlDetailSchema = z.object({
  "catalog_id": z.string().uuid(),
  "framework_id": z.string(),
  "framework_version": z.string(),
  "selected": z.boolean(),
  "control_id": z.string(),
  "title": z.string(),
  "requirement": z.string(),
  "family": z.string(),
  "severity": z.enum(["critical", "high", "medium", "low"]),
  "status": z.enum(["compliant", "partial", "non_compliant", "not_applicable", "not_assessed"]),
  "confidence": z.enum(["auto", "structural", "manual", "override", ""]),
  "treatment": z.enum(["none", "exception", "not_applicable"]),
  "evidence": z.record(z.string(), z.unknown()).optional(),
  "crosswalk": z.array(crosswalkEntrySchema),
  "override": controlOverrideDetailSchema.optional(),
  "executions": z.object({
    "since": z.string().datetime({ offset: true }),
    "first_at": z.string().datetime({ offset: true }).optional(),
    "last_at": z.string().datetime({ offset: true }).optional(),
    "runs": z.number().int().min(0),
    "met": z.number().int().min(0),
    "partly": z.number().int().min(0),
    "not_met": z.number().int().min(0),
    "other": z.number().int().min(0)
  }).optional(),
  "remediation": z.string().default(""),
  "evaluator_version": z.string().default(""),
  "assessed_at": z.string().default(""),
  "section": z.string().default(""),
  "supplier": z.string().default(""),
  "population": z.string().default(""),
  "owner_name": z.string().default(""),
  "owner_role": z.string().default(""),
  "reviewer_name": z.string().default(""),
  "reviewer_role": z.string().default(""),
  "customer_control_id": z.string().default(""),
  "attestation_statement": z.string().default(""),
  "attestation_expires_at": z.string().default(""),
  "attestation_cited_from": z.string().default(""),
  "exception_expires_at": z.string().default(""),
  "compensating_control": z.string().default(""),
  "next_review_due_at": z.string().default(""),
  "attested_by_email": z.string().optional(),
  "attest_reviewed_by": z.string().optional(),
  "attested_at": z.string().datetime({ offset: true }).optional(),
  "attest_reviewed_at": z.string().datetime({ offset: true }).optional(),
  "owner_admin_id": z.string().uuid().optional(),
  "reviewer_admin_id": z.string().uuid().optional(),
  "attestation_cited_from_id": z.string().uuid().optional(),
  "design_only": z.boolean().default(false),
  "supporting_report_kinds": z.array(z.string()).default([])
});
